import styled from '@emotion/styled';
import { ModalStyled } from '@nike/nike-design-system-components';

export const StyledDialog = styled(ModalStyled)`
  overflow: visible;

  & section {
    &:before {
      width: unset;
    }
  }
`;
